import { useCallback, useEffect, useRef } from 'react'
import { useAccount } from 'wagmi'
import { resetUserState } from 'state/global/actions'
import { clearAllTransactions } from 'state/transactions/actions'
import { useWagmi } from 'libs/wagmi'
import { useAppDispatch } from 'state'

const usePreviousValue = (value: any) => {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  })

  return ref.current
}

const useHasValueChanged = (value: any) => {
  const oldValue = usePreviousValue(value)

  return oldValue !== undefined && oldValue !== value
}

export const useAccountEventListener = () => {
  const dispatch = useAppDispatch()
  const { chainId } = useWagmi()

  const handleChange = useCallback(() => {
    dispatch(resetUserState())
    if (chainId) {
      dispatch(clearAllTransactions({ chainId }))
    }
  }, [chainId, dispatch])

  const { address } = useAccount()

  const isAddressChanged = useHasValueChanged(address)
  const isChainIdChanged = useHasValueChanged(chainId)

  useEffect(() => {
    if ((address && isAddressChanged) || isChainIdChanged) {
      handleChange()
    }
  }, [address, chainId, isAddressChanged, isChainIdChanged, handleChange])
}
